import { newsListPath } from "../../../newsList/newsListPath"

interface NavItem {
	key: string
	label: string
	url: string
}

interface GetDealershipListNavItemsProps {
	hasNewsAccess: boolean
	isMarketManager: boolean
	labels: { dealerships: string; news: string }
}

export const getDealershipListNavItems = ({
	hasNewsAccess,
	isMarketManager,
	labels,
}: GetDealershipListNavItemsProps): NavItem[] => [
	...(isMarketManager ? [{ key: "dealerships", label: labels.dealerships, url: "/" }] : []),
	...(hasNewsAccess ? [{ key: "news", label: labels.news, url: newsListPath }] : []),
]
